import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['loader'];

  loaded() {
    this.loaderTarget.classList.add('d-none');
  }
}
